import React from 'react';
import { Icon } from './Icon.js';
export const IconMerge = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 12H12", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 5H8L12 12L8 19H3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M18 16L22 12L18 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMerge.js.map